
import changeFile from './tcplayer-vod-change-file.html';
import continuePlay from './tcplayer-vod-continue-play.html';
import base from './tcplayer-vod-base.html';
import baseNativeControl from './tcplayer-vod-base-native-control.html';
// import masterPlayList from './tcplayer-vod-hls-masterplaylist.html';
// import imagePatch from './tcplayer-vod-image-patch.html';
// import logo from './tcplayer-vod-logo.html';
import language from './tcplayer-vod-language.html';
import multi from './tcplayer-vod-mutil.html';
import sizeAdaptive from './tcplayer-vod-size-adaptive.html';
import subtitles from './tcplayer-vod-subtitles.html';
import vttThumbnailSrc from './tcplayer-vod-vtt-thumbnail-src.html';
import vttThumbnail from './tcplayer-vod-vtt-thumbnail.html';
import mirror from './tcplayer-vod-mirror.html';
import event from './tcplayer-vod-event.html';
import dynamicWatermark from './tcplayer-vod-dynamic-watermark.html';
import dash from './tcplayer-vod-base-v4-dash.html';
import qualityApi from './tcplayer-vod-base-v4-quality-api.html';
import fileStatistic from './tcplayer-vod-change-file-statistic.html';
import progressMarker from './tcplayer-vod-progress-marker.html';
import hlsMasterplaylist from './tcplayer-vod-hls-masterplaylist.html';
import levelSwitchTips from './tcplayer-vod-level-switch-tips.html';
import key from './tcplayer-vod-key.html';
import trial from './tcplayer-vod-trial.html';
import customError from './tcplayer-vod-custom-error.html';
import poster from './tcplayer-vod-poster.html';
import playbackRate from './tcplayer-vod-playbackrate.html';
import playlist from './tcplayer-vod-playlist.html';
import customUI from './tcplayer-vod-custom-ui.html';
import playurl from './tcplayer-vod-play-url.html';
import playfileid from './tcplayer-vod-play-fileid.html';
import barrage from './tcplayer-vod-barrage.html';
import ghostWatermark from './tcplayer-vod-ghost-watermark.html';



export const source = {
  base,
  baseNativeControl,
  changeFile,
  continuePlay,
  language,
  multi,
  sizeAdaptive,
  subtitles,
  vttThumbnail,
  vttThumbnailSrc,
  mirror,
  event,
  dynamicWatermark,
  dash,
  qualityApi,
  fileStatistic,
  progressMarker,
  hlsMasterplaylist,
  levelSwitchTips,
  key,
  trial,
  customError,
  poster,
  playbackRate,
  playlist,
  customUI,
  playurl,
  playfileid,
  barrage,
  ghostWatermark
  // logo,
  // masterPlayList,
  // imagePatch,
}